import {register} from '@shopify/theme-sections'
import React from 'react'
import {createRoot} from 'react-dom/client'

import Limelight from '@dotdev/limelight/limelight'

import Cookies from 'js-cookie'
import $ from 'jquery'
import AlgoliaSearchBar from '../components/algolia/search/searchBar/small-search'
import 'slick-carousel'

import AffiliateProgram from '../modules/affiliate'
import CheckForUTMvariables from '../modules/utm-fields'

import '../../styles/components/theme-header.scss'
import '../../styles/components/mobile-navigation.scss'
import '../../styles/components/announcement-bar.scss'
import '../../styles/components/navigation.scss'
import '../../styles/components/header-search.scss'
import '../../styles/components/algolia-search-bar.scss'

// Watch the Mobile Menu when active - to face out RHS Menu Links
function observeMobileMenu() {
    const targetNode = document.getElementById(`mobile-navigation-trigger`)

    const mobileMenu = document.getElementById(`mobile-menu`)

    // Callback function to execute when mutations are observed
    mobileMenu.addEventListener(`click`, () => {
        const mobileMenu = document.getElementById(`mobile-navigation`)
        const announcementBar = document.getElementById(`announcement-bar`)
        if (targetNode.classList.contains(`active`)) {
            mobileMenu.classList.add(`hidden`)
            targetNode.classList.remove(`active`)
            if (announcementBar) {
                announcementBar.classList.remove(`hidden`)
            }
        } else {
            mobileMenu.classList.remove(`hidden`)
            targetNode.classList.add(`active`)
            if (announcementBar) {
                announcementBar.classList.add(`hidden`)
            }
        }
    })

}

// Create Custom Cart Counter
function customCartCounter(cartCounter) {
    let shopifyItemsCount = cartCounter.data(`item-count`)
        ? cartCounter.data(`item-count`)
        : 0
    let numOfRentalProducts = 0
    let totalCartCount = 0

    if (
        Cookies.get(`_rent_products`) &&
        Cookies.get(`_rent_products`) != undefined
    ) {
        let currentRentalProducts = Cookies.get(`_rent_products`).split(`,`)
        numOfRentalProducts = currentRentalProducts.length
    }

    totalCartCount = shopifyItemsCount + numOfRentalProducts

    if (totalCartCount > 0) {
        cartCounter.text(totalCartCount)
        cartCounter.removeClass(`hide`)
    } else {
        cartCounter.addClass(`hide`)
    }
}

export default register(`theme-header`, {
    onLoad() {
        // Call the UTM Field Function
        CheckForUTMvariables()

        // Call Affiliate function
        AffiliateProgram()

        // Observe Mobile Menu
        observeMobileMenu()

        // Show cart popup on update
        document.addEventListener(`cart:updated`, () => {
            if (window.theme.template.indexOf(`cart`)) {
                this.cartPopup.show()
            }
            // Execute Custom Counter
            customCartCounter($(`.links-right__cart-badge`))
        })

        // Execute Custom Counter
        customCartCounter($(`.links-right__cart-badge`))

        $(`#mobile-navigation [data-item-target]`).on(`click`, function () {
            let ID = $(this).data(`item-target`)
            let parent = $(`#mobile-navigation`)
                .find(`#` + ID)
                .parent()
            $(`#mobile-navigation > div.second-level.is-active`).addClass(`reversed`)
            $(`#mobile-navigation > div`).removeClass(`is-active`)
            parent.find(`> div`).hide()

            setTimeout(() => {
                parent.addClass(`is-active`)
                parent.find(`#` + ID).show()
            }, 100)
        })

        $(`#mobile-navigation [data-back]`).on(`click`, function () {
            let item = $(this).data(`back`)
            $(`#mobile-navigation > div`).removeClass(`is-active`)
            $(`#mobile-navigation`)
                .find(`.` + item)
                .removeClass(`reversed`)
            $(`#mobile-navigation`)
                .find(`.` + item)
                .addClass(`is-active`)
        })

        $(`[data-close-announcement]`).on(`click`, function () {
            $(this)
                .parent()
                .slideUp(150)
        })

        $(`.has-subcategory`).hover(function () {
            $(this)
                .parent()
                .find(`.has-subcategory`)
                .removeClass(`is-active`)
            $(this).addClass(`is-active`)
        })


        $(`[data-menu-item]`).hover(
            function () {
                $(this)
                    .parent()
                    .find(`[data-menu-item]`)
                    .addClass(`light`)
                $(this)
                    .removeClass(`light`)
                    .addClass(`is-active`)
                if ($(this).attr(`data-menu-item`) == `has-child`) {
                    $(`.main-overlay`).addClass(`is-active`)
                }
            },
            function () {
                $(this)
                    .parent()
                    .find(`[data-menu-item]`)
                    .removeClass(`light`)
                $(this).removeClass(`is-active`)
                $(`.main-overlay`).removeClass(`is-active`)
            }
        )

        document.querySelector(`[data-target="#SearchContainer"]`).addEventListener(`click`, () => {
            document.querySelector(`#SearchContainer`).classList.add(`visible`)
        })

        const country = this.container.dataset.shopCountry
        const shopifyAlgoliaIndex = this.container.dataset.algoliaIndex
        let searchContainerRoot = createRoot(this.container.querySelector(`#SearchContainer`))

        searchContainerRoot.render(
            <AlgoliaSearchBar country={country} algoliaIndex={shopifyAlgoliaIndex}/>
        )


        // Mobile submenus
        const childDrawers = document.querySelectorAll(
            `[data-trigger="drawer-menu"]`
        )

        window.drawerMenus = []
        if (childDrawers && childDrawers.length > 0) {
            childDrawers.forEach((drawer, index) => {
                window.drawerMenus[index] = new Limelight(`${drawer.dataset.target}`, {
                    beforeShowCallback: () => {
                        drawer.closest(`.theme-nav-links`).classList.add(`invisible`)
                    },
                    beforeHideCallback: function () {
                        drawer.closest(`.theme-nav-links`).classList.remove(`invisible`)
                    },
                })
            })
        }

        const childDrawersSecond = document.querySelectorAll(
            `[data-trigger="drawer-menu-second-level"]`
        )
        window.drawerMenusSecond = []

        if (childDrawersSecond && childDrawersSecond.length > 0) {
            childDrawersSecond.forEach((drawer, index) => {
                window.drawerMenusSecond[index] = new Limelight(`${drawer.dataset.target}`, {
                    beforeShowCallback: function () {
                        //drawer.closest('.theme-nav-links-second').classList.remove('visible');
                        drawer.closest(`.theme-nav-links-second`).classList.add(`invisible`)
                        //element.element.querySelector('[data-scroll-state]').scrollTop = 0;
                    },
                    beforeHideCallback: function () {
                        drawer
                            .closest(`.theme-nav-links-second`)
                            .classList.remove(`invisible`)
                    },
                })
            })
        }

        // Close Announcment
        const closeAnnouncement = document.querySelector(
            `[data-close-announcement]`
        )
        if (closeAnnouncement) {
            closeAnnouncement.addEventListener(`click`, e => {
                e.preventDefault()
                const announcementType =
                    closeAnnouncement.parentElement.dataset.navbarAnnouncement
                Cookies.set(`_closeAnnouncement`, announcementType, {expires: 60})
            })
        }

        if (Cookies.get(`_closeAnnouncement`)) {
            const template = Cookies.get(`_closeAnnouncement`)
            const activeAnnouncement = document.querySelector(
                `[data-navbar-announcement="${template}"]`
            )
            if (activeAnnouncement) {
                activeAnnouncement.classList.add(`hide`)
            }
        }
    },
})
